var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.964 0.391113H5.76683C2.55418 0.391113 0.410156 2.69131 0.410156 5.98513V13.7086C0.410156 17.0054 2.54845 19.3026 5.76683 19.3026H13.963C17.1824 19.3026 19.3217 17.0054 19.3217 13.7086V5.98513C19.3217 2.68839 17.1825 0.391113 13.964 0.391113ZM5.76676 1.80957H13.964C16.3757 1.80957 17.9033 3.45011 17.9033 5.98523V13.7087C17.9033 16.2439 16.3755 17.8843 13.963 17.8843H5.76676C3.35533 17.8843 1.82845 16.2441 1.82845 13.7087V5.98523C1.82845 3.45333 3.3606 1.80957 5.76676 1.80957ZM13.733 7.10171C13.4561 6.82475 13.007 6.82475 12.7301 7.10171L8.74301 11.0874L7.00042 9.34545L6.92087 9.2768C6.6432 9.07086 6.24921 9.09384 5.9975 9.34566C5.7206 9.62267 5.7207 10.0717 5.99771 10.3486L8.2425 12.5924L8.32204 12.6611C8.59967 12.867 8.99359 12.8441 9.24533 12.5923L13.733 8.10464L13.8017 8.0251C14.0077 7.74747 13.9848 7.35348 13.733 7.10171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound);
export default __webpack_public_path__ + "static/media/check-round.9c69a594a9c94c44e2b925e8fbf6d094.svg";
export { ForwardRef as ReactComponent };